export default __webpack_public_path__ + "static/media/glasses-beige.c344488d.svg";